(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-embudo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quiz-embudo')) {
    const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const LETRAS = ['A', 'B', 'C', 'D'];
    const esperar = (ms) => new Promise((r) => setTimeout(r, ms));
    const escapar = (t) =>
      String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const fecha = (dias = 0) => {
      const d = new Date();
      d.setDate(d.getDate() + dias);
      return d.getDate() + ' de ' + MESES[d.getMonth()];
    };
    const conFechas = (texto) =>
      String(texto).replace(/\{(mes|fecha):\+(\d{1,4})\}/g, (_, tipo, n) => {
        const d = new Date();
        d.setDate(d.getDate() + Number(n));
        return tipo === 'mes' ? MESES[d.getMonth()] + ' de ' + d.getFullYear() : d.getDate() + ' de ' + MESES[d.getMonth()];
      });
    const unir = (lista) => (lista.length < 2 ? lista.join('') : lista.slice(0, -1).join(', ') + ' y ' + lista[lista.length - 1]);
    const publicar = (nombre, datos) => {
      try {
        if (/[?&]demo=1\b/.test(window.location.search)) return;
        window.Shopify?.analytics?.publish?.(nombre, datos || {});
        if (typeof window.clarity === 'function') window.clarity('event', nombre);
      } catch (e) {}
    };

    // Correo: forma básica y sugerencia para dominios mal escritos («gmial.com»).
    const FORMA_CORREO = /^[^\s@<>()[\]\\,;:"']+@[^\s@<>()[\]\\,;:"']+\.[a-z]{2,}$/i;
    const DOMINIOS_COMUNES = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com.mx', 'yahoo.com', 'icloud.com', 'live.com.mx', 'live.com', 'outlook.es', 'hotmail.es', 'msn.com', 'me.com', 'yahoo.es', 'hotmail.com.ar', 'yahoo.com.ar', 'live.com.ar'];
    const OTROS_REALES = ['mail.com', 'gmx.com', 'gmx.es', 'aol.com', 'ymail.com', 'rocketmail.com', 'proton.me', 'protonmail.com', 'zoho.com', 'yandex.com', 'outlook.com.ar'];
    const correoValido = (texto) => {
      const correo = String(texto || '').trim().toLowerCase();
      return correo && correo.length <= 254 && FORMA_CORREO.test(correo) ? correo : null;
    };
    const distancia = (a, b) => {
      let anterior = Array.from({ length: b.length + 1 }, (_, i) => i);
      for (let i = 1; i <= a.length; i++) {
        const fila = [i];
        for (let j = 1; j <= b.length; j++) {
          fila[j] = Math.min(anterior[j] + 1, fila[j - 1] + 1, anterior[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
        anterior = fila;
      }
      return anterior[b.length];
    };
    const sugerirCorreo = (correo) => {
      const arroba = correo.lastIndexOf('@');
      const usuario = correo.slice(0, arroba);
      const dominio = correo.slice(arroba + 1);
      if (DOMINIOS_COMUNES.includes(dominio) || OTROS_REALES.includes(dominio)) return null;
      let mejor = null;
      let menor = Infinity;
      DOMINIOS_COMUNES.forEach((comun) => {
        const d = distancia(dominio, comun);
        if (d < menor) {
          menor = d;
          mejor = comun;
        }
      });
      return menor <= (dominio.length >= 8 ? 2 : 1) ? usuario + '@' + mejor : null;
    };

    class QuizEmbudo extends HTMLElement {
      connectedCallback() {
        this.portada = this.querySelector('[data-pantalla="portada"]');
        this.analisis = this.querySelector('[data-pantalla="analisis"]');
        this.captura = this.querySelector('[data-pantalla="captura"]');
        const todas = [...this.querySelectorAll('.quiz__pasos [data-pantalla]')];
        this.pasos = todas.filter((p) => p.dataset.pantalla === 'pregunta' || p.dataset.pantalla === 'pantalla');
        this.resultados = todas.filter((p) => p.dataset.pantalla === 'resultado');
        this.preguntas = this.pasos.filter((p) => p.dataset.pantalla === 'pregunta');
        this.barra = this.querySelector('[data-barra]');
        this.avance = this.querySelector('[data-avance]');
        this.contador = this.querySelector('[data-contador]');
        this.indice = -1;
        this.empezado = false;
        this.niveles = (this.dataset.niveles || 'Bajo, Medio, Alto')
          .split(',')
          .map((n) => n.trim())
          .filter(Boolean);

        this.querySelector('[data-empezar]')?.addEventListener('click', () => {
          if (!this.empezado) publicar('quiz_empezado');
          this.empezado = true;
          this.irA(0);
        });
        this.querySelector('[data-volver]')?.addEventListener('click', () => history.back());

        this.pasos.forEach((paso, i) => {
          const multiple = paso.dataset.tipo === 'multiple';
          const seguir = paso.querySelector('[data-seguir]');
          paso.querySelectorAll('[data-opcion]').forEach((opcion) => {
            opcion.addEventListener('click', () => {
              if (multiple) {
                opcion.setAttribute('aria-pressed', String(opcion.getAttribute('aria-pressed') !== 'true'));
                if (seguir) seguir.disabled = !paso.querySelector('[data-opcion][aria-pressed="true"]');
              } else {
                paso.querySelectorAll('[data-opcion]').forEach((o) => o.setAttribute('aria-pressed', String(o === opcion)));
                clearTimeout(this.demora);
                this.demora = setTimeout(() => this.siguiente(i), 220);
              }
            });
          });
          if (seguir) seguir.addEventListener('click', () => this.siguiente(i));
        });

        this.alVolver = (e) => {
          const estado = e.state && e.state.quiz;
          if (estado === undefined || estado === null) {
            this.irA(-1, false);
          } else if (estado === 'resultado') {
            this.irA(this.pasos.length - 1, false);
          } else {
            this.irA(Number(estado), false);
          }
        };
        window.addEventListener('popstate', this.alVolver);

        if (window.Shopify && window.Shopify.designMode) this.prepararEditor();
        this.querySelectorAll('[data-hoy]').forEach((el) => (el.textContent = fecha(0)));
        this.querySelectorAll('[data-total-preguntas]').forEach((el) => (el.textContent = String(this.preguntas.length)));
        if (this.captura) this.restaurarSiVuelve();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.alVolver);
      }

      mostrar(pantalla) {
        [this.portada, this.analisis, this.captura, ...this.pasos, ...this.resultados].forEach((p) => {
          if (p) p.hidden = p !== pantalla;
        });
        const enPaso = this.pasos.includes(pantalla);
        this.barra.hidden = !enPaso;
        this.avance.hidden = !enPaso;
        const arriba = this.getBoundingClientRect().top + window.scrollY - 80;
        if (window.scrollY > arriba) window.scrollTo({ top: Math.max(0, arriba) });
      }

      irA(i, guardar = true) {
        this.indice = i;
        if (i < 0) {
          this.mostrar(this.portada);
          return;
        }
        const paso = this.pasos[i];
        if (!paso) return;
        this.mostrar(paso);
        const hechas = this.pasos.slice(0, i + 1).filter((p) => p.dataset.pantalla === 'pregunta').length;
        const total = this.preguntas.length;
        // La última pregunta, o una pantalla justo antes de ella.
        const ultima = hechas === total - (paso.dataset.pantalla === 'pregunta' ? 0 : 1) && hechas > 0;
        // Cerca del final, que es donde más gente abandona, el contador
        // cuenta lo que falta («Faltan 2 para tu resultado»).
        const faltan = total - hechas + (paso.dataset.pantalla === 'pregunta' ? 1 : 0);
        const cercaDelFinal = this.dataset.textoFaltan && faltan > 1 && faltan <= 2;
        this.contador.textContent =
          ultima && this.dataset.textoUltima
            ? this.dataset.textoUltima
            : cercaDelFinal
            ? this.dataset.textoFaltan.replace('{n}', String(faltan))
            : (this.dataset.textoPregunta || 'Pregunta {n} de {total}')
                .replace('{n}', String(Math.max(1, hechas)))
                .replace('{total}', String(total));
        this.avance.style.setProperty('--avance', Math.round(((i + 1) / (this.pasos.length + 1)) * 100) + '%');
        if (guardar) {
          history.pushState({ quiz: i }, '');
          // Un evento por paso: con esto se ve en qué pregunta abandonan.
          publicar('quiz_paso', { paso: i + 1, total: this.pasos.length, tipo: paso.dataset.pantalla, id: paso.dataset.id || '' });
        }
      }

      siguiente(i) {
        if (i < this.pasos.length - 1) this.irA(i + 1);
        else this.terminar();
      }

      async terminar() {
        publicar('quiz_terminado');
        if (this.dataset.analisis === 'true' && this.analisis) await this.correrAnalisis();
        if (this.captura) await this.pedirCorreo();
        if (this.dataset.alTerminar === 'ir') {
          this.irDirecto();
          return;
        }
        this.mostrarResultado();
      }

      // La página a la que lleva el resultado (la de su bloque o la de la
      // sección), con el resultado y los parámetros del anuncio (utm, fbclid).
      urlDestino(ganador) {
        const destino = ganador.dataset.destino || ganador.querySelector('[data-ir]')?.getAttribute('href') || '/';
        try {
          const url = new URL(destino, window.location.origin);
          new URLSearchParams(window.location.search).forEach((valor, clave) => {
            if (clave === 'quiz' || clave === 'customer_posted') return;
            if (!url.searchParams.has(clave)) url.searchParams.set(clave, valor);
          });
          url.searchParams.set('resultado', ganador.dataset.id);
          return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.toString();
        } catch (e) {
          return destino;
        }
      }

      // Sin pantalla de resultado: lleva directo a la página, que muestra el
      // titular y el botón de ese resultado.
      irDirecto() {
        const ganador = this.elegirGanador();
        if (!ganador) return;
        const id = ganador.dataset.id;
        publicar('quiz_resultado', { resultado: id });
        publicar('quiz_clic_oferta', { resultado: id, directo: true });
        try {
          sessionStorage.setItem('quiz-resultado', id);
        } catch (e) {}
        window.location.href = this.urlDestino(ganador);
      }

      // Pide el correo antes del resultado y lo guarda como cliente de Shopify,
      // con una etiqueta del quiz y otra del resultado (Shopify Email o Klaviyo
      // lo toman desde ahí). Si falla el envío, igual muestra el resultado.
      pedirCorreo() {
        this.mostrar(this.captura);
        const form = this.captura.querySelector('[data-captura]');
        const campo = form.querySelector('input[type="email"]');
        const mensaje = form.querySelector('[data-captura-mensaje]');
        const omitir = this.captura.querySelector('[data-captura-omitir]');
        const boton = form.querySelector('button[type="submit"]');
        const id = this.elegirGanador()?.dataset.id || '';
        let sugerido = false;
        campo.focus({ preventScroll: true });

        const avisar = (html) => {
          mensaje.innerHTML = html;
          mensaje.hidden = !html;
        };

        return new Promise((listo) => {
          const seguir = () => {
            this.limpiarCaptura?.();
            this.limpiarCaptura = null;
            listo();
          };
          const alOmitir = () => {
            publicar('quiz_correo_omitido', { resultado: id });
            seguir();
          };
          const alEnviar = async (e) => {
            e.preventDefault();
            const correo = correoValido(campo.value);
            if (!correo) {
              avisar(escapar(this.dataset.capturaError || 'Revisá el correo.'));
              campo.focus();
              return;
            }
            const sugerencia = sugerirCorreo(correo);
            if (sugerencia && !sugerido) {
              sugerido = true;
              const texto = escapar(this.dataset.capturaSugerencia || '¿Quisiste decir {correo}?').replace(
                '{correo}',
                '<button type="button" class="button-unstyled" data-usar>' + escapar(sugerencia) + '</button>'
              );
              avisar(texto);
              mensaje.querySelector('[data-usar]')?.addEventListener('click', () => {
                campo.value = sugerencia;
                avisar('');
                form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
              });
              return;
            }
            avisar('');
            boton.setAttribute('aria-busy', 'true');
            boton.disabled = true;
            const etiqueta = this.dataset.capturaEtiqueta || 'quiz';
            const etiquetas = etiqueta + (id ? ', ' + etiqueta + '-' + id : '');
            publicar('quiz_correo', { resultado: id });
            // Primero en segundo plano. Si Shopify pide verificar que no es un
            // robot, se manda el formulario de forma normal y el quiz vuelve
            // directo al resultado (las respuestas quedan guardadas).
            const guardado = await this.enviarCorreo(correo, etiquetas);
            if (!guardado) {
              this.guardarEstado();
              this.enviarFormulario(correo, etiquetas);
              return;
            }
            boton.removeAttribute('aria-busy');
            boton.disabled = false;
            seguir();
          };
          // Si vuelve atrás y termina de nuevo, no quedan escuchas viejas.
          this.limpiarCaptura?.();
          this.limpiarCaptura = () => {
            form.removeEventListener('submit', alEnviar);
            omitir?.removeEventListener('click', alOmitir);
          };
          form.addEventListener('submit', alEnviar);
          omitir?.addEventListener('click', alOmitir);
        });
      }

      async enviarCorreo(correo, etiquetas) {
        const datos = new FormData();
        datos.append('form_type', 'customer');
        datos.append('utf8', '✓');
        datos.append('contact[email]', correo);
        datos.append('contact[tags]', etiquetas);
        const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const respuesta = await Promise.race([
            fetch(raiz + 'contact', { method: 'POST', body: datos, headers: { Accept: 'text/html' } }),
            esperar(6000).then(() => null),
          ]);
          return Boolean(respuesta && respuesta.ok);
        } catch (error) {
          return false;
        }
      }

      enviarFormulario(correo, etiquetas) {
        const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const vuelta = new URL(window.location.href);
        vuelta.searchParams.set('quiz', 'resultado');
        vuelta.hash = '';
        const form = document.createElement('form');
        form.method = 'post';
        form.action = raiz + 'contact';
        form.acceptCharset = 'UTF-8';
        form.hidden = true;
        const campos = {
          form_type: 'customer',
          utf8: '✓',
          'contact[email]': correo,
          'contact[tags]': etiquetas,
          // Una sola barra al principio: «//otro-sitio» se leería como otro sitio.
          return_to: '/' + vuelta.pathname.replace(/^[\\/]+/, '').replace(/^(%2f|%5c)+/i, '') + vuelta.search,
        };
        Object.entries(campos).forEach(([nombre, valor]) => {
          const campo = document.createElement('input');
          campo.type = 'hidden';
          campo.name = nombre;
          campo.value = valor;
          form.appendChild(campo);
        });
        document.body.appendChild(form);
        form.submit();
      }

      claveEstado() {
        return 'quiz-estado-' + (this.dataset.seccion || '');
      }

      guardarEstado() {
        const respuestas = this.preguntas.map((p) =>
          [...p.querySelectorAll('[data-opcion]')].map((o, i) => (o.getAttribute('aria-pressed') === 'true' ? i : -1)).filter((i) => i >= 0)
        );
        try {
          sessionStorage.setItem(this.claveEstado(), JSON.stringify({ respuestas, hora: Date.now() }));
        } catch (e) {}
      }

      // Al volver del formulario (o de la verificación de Shopify), muestra el resultado.
      restaurarSiVuelve() {
        let parametros;
        try {
          parametros = new URLSearchParams(window.location.search);
        } catch (e) {
          return;
        }
        if (parametros.get('quiz') !== 'resultado' && parametros.get('customer_posted') !== 'true') return;
        let estado = null;
        try {
          estado = JSON.parse(sessionStorage.getItem(this.claveEstado()) || 'null');
        } catch (e) {}
        if (!estado || !Array.isArray(estado.respuestas) || Date.now() - (estado.hora || 0) > 6 * 60 * 60 * 1000) return;
        this.preguntas.forEach((p, i) => {
          const elegidas = estado.respuestas[i] || [];
          p.querySelectorAll('[data-opcion]').forEach((o, j) => o.setAttribute('aria-pressed', String(elegidas.includes(j))));
        });
        this.empezado = true;
        this.mostrarResultado();
      }

      elegirGanador() {
        if (!this.resultados.length) return null;
        const { total } = this.puntos();
        let ganador = this.resultados[0];
        this.resultados.forEach((r) => {
          if ((total[r.dataset.clave] || 0) > (total[ganador.dataset.clave] || 0)) ganador = r;
        });
        return ganador;
      }

      async correrAnalisis() {
        this.mostrar(this.analisis);
        const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const pasos = [...this.analisis.querySelectorAll('[data-analisis-paso]')];
        const confirmaciones = [...this.analisis.querySelectorAll('[data-confirmacion]')];
        const total = quieto ? 600 : Number(this.dataset.duracion || 5000);
        const porPaso = pasos.length ? total / pasos.length : total;
        pasos.forEach((p) => p.querySelector('.quiz__analisis-pista span')?.style.setProperty('--lleno', '0%'));
        confirmaciones.forEach((c) => (c.hidden = true));
        for (let k = 0; k < pasos.length; k++) {
          const relleno = pasos[k].querySelector('.quiz__analisis-pista span');
          if (relleno) {
            relleno.style.setProperty('--tiempo', porPaso + 'ms');
            await esperar(30);
            relleno.style.setProperty('--lleno', '100%');
          }
          await esperar(porPaso);
          const confirmacion = confirmaciones[k];
          if (confirmacion) {
            confirmacion.hidden = false;
            confirmacion.querySelector('[data-responder]:last-child')?.focus({ preventScroll: true });
            await new Promise((listo) => {
              confirmacion.querySelectorAll('[data-responder]').forEach((b) =>
                b.addEventListener('click', () => listo(), { once: true })
              );
            });
            confirmacion.hidden = true;
          }
        }
        await esperar(quieto ? 0 : 350);
      }

      elegidas(paso) {
        return [...paso.querySelectorAll('[data-opcion][aria-pressed="true"]')];
      }

      puntos() {
        const total = { A: 0, B: 0, C: 0, D: 0 };
        const maximo = { A: 0, B: 0, C: 0, D: 0 };
        this.preguntas.forEach((p) => {
          const opciones = [...p.querySelectorAll('[data-opcion]')];
          const multiple = p.dataset.tipo === 'multiple';
          LETRAS.forEach((letra) => {
            const valores = opciones.map((o) => Number(o.dataset['puntos' + letra] || 0));
            maximo[letra] += multiple ? valores.reduce((a, b) => a + b, 0) : Math.max(0, ...valores);
          });
          this.elegidas(p).forEach((o) => {
            LETRAS.forEach((letra) => (total[letra] += Number(o.dataset['puntos' + letra] || 0)));
          });
        });
        return { total, maximo };
      }

      mostrarResultado() {
        if (!this.resultados.length) return;
        const { total, maximo } = this.puntos();
        const ganador = this.elegirGanador();

        // Repite lo que eligió: {respuesta:id-de-la-pregunta}
        const ecos = {};
        this.preguntas.forEach((p) => {
          if (p.dataset.id) ecos[p.dataset.id] = unir(this.elegidas(p).map((o) => o.dataset.eco));
        });
        ganador.querySelectorAll('[data-tokens]').forEach((el) => {
          if (!el.dataset.original) el.dataset.original = el.innerHTML;
          el.innerHTML = el.dataset.original.replace(/\{respuesta:([a-z0-9_-]+)\}/gi, (_, id) => escapar(ecos[id.toLowerCase()] || ''));
        });
        ganador.querySelectorAll('[data-fechas]').forEach((el) => {
          if (!el.dataset.original) el.dataset.original = el.textContent;
          el.textContent = conFechas(el.dataset.original);
        });

        // Medidores: cuánto sumó cada letra contra lo máximo posible.
        ganador.querySelectorAll('[data-medidor]').forEach((m) => {
          const letra = m.dataset.medidor;
          const max = maximo[letra] || 0;
          const porcentaje = max > 0 ? Math.round(Math.min(94, Math.max(8, ((total[letra] || 0) / max) * 100))) : 8;
          const nivel = this.niveles[Math.min(this.niveles.length - 1, Math.floor((porcentaje / 100) * this.niveles.length))] || '';
          const marca = m.querySelector('.quiz__medidor-marca');
          if (marca) {
            marca.style.setProperty('--valor', '8%');
            requestAnimationFrame(() => requestAnimationFrame(() => marca.style.setProperty('--valor', porcentaje + '%')));
          }
          const texto = m.querySelector('[data-nivel]');
          if (texto) texto.textContent = nivel;
        });

        // El botón lleva al producto con el resultado y los parámetros del anuncio.
        const id = ganador.dataset.id;
        const href = this.urlDestino(ganador);
        ganador.querySelectorAll('[data-ir]').forEach((a) => {
          a.href = href;
          a.addEventListener('click', () => publicar('quiz_clic_oferta', { resultado: id }), { once: true });
        });

        this.mostrar(ganador);
        history.pushState({ quiz: 'resultado' }, '');
        publicar('quiz_resultado', { resultado: id });
        try {
          sessionStorage.setItem('quiz-resultado', id);
        } catch (e) {}
      }

      prepararEditor() {
        document.addEventListener('shopify:block:select', (e) => {
          if (!this.contains(e.target)) return;
          const pantalla = e.target.closest('[data-pantalla]');
          if (!pantalla) return;
          if (pantalla.dataset.pantalla === 'resultado') {
            this.mostrar(pantalla);
            pantalla.querySelectorAll('.quiz__medidor-marca').forEach((m) => m.style.setProperty('--valor', '50%'));
          } else if (this.pasos.includes(pantalla)) {
            this.irA(this.pasos.indexOf(pantalla), false);
          }
        });
      }
    }

    customElements.define('quiz-embudo', QuizEmbudo);
  }

  } catch(e) { console.error(e); }
})();
})();
